export default __webpack_public_path__ + "static/media/ransomewareRealcase-en.a10227c9.png";